import React from 'react';
import { connect } from 'react-redux';

/**
 * Modal window showing during account creation
 */

import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const CreatingAccount = ({open}) => {
  return (
    <Dialog
        fullScreen={false}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <FormattedMessage id='account.creating.dialog.title' />
        </DialogTitle>
        <DialogContent>
          <FormattedMessage id='account.creating.dialog.content' />
        </DialogContent>
    </Dialog>
  );
}

export default connect( 
  ({creatingUser}) => { 
    return { 
      open: creatingUser 
    } 
  } 
)(CreatingAccount)


// WEBPACK FOOTER //
// ./src/components/CreatingAccount.js